<!--
 * Description  :
 * Date         :2021-12-23 09:41:32
 * LastEditors  :chenjia
 * LastEditTime :2024-07-12 11:50:58
 * FilePath     :\abackup-pay\src\views\Refund.vue
-->
<template>
  <div class="refund">
    <div class="refund-mn">
      <h2>查询订单信息</h2>
      <el-form
        :model="refundForm"
        ref="refundForm"
        label-width="130px"
        class="refund-form"
        :rules="rules"
      >
        <el-form-item label="输入订单号:" prop="orderId">
          <el-input v-model="refundForm.orderId" autocomplete="off"></el-input>
        </el-form-item>
        <el-button
          :loading="btnLoadingQuery"
          type="primary"
          class="btn-bl"
          @click="queryOrdersFn('numberValidateForm')"
        >
          查询订单
        </el-button>
      </el-form>

      <div class="detail" v-if="productDetails != null">
        <h2>确定订单详情</h2>
        <div class="txt-x">
          <p>
            订单号：<span>{{ productDetails.order_no }}</span>
          </p>
          <p>
            软件名：<span>{{ productDetails.show_name }}</span>
          </p>
          <p>
            版本：<span>{{ productDetails.show_version }}</span>
          </p>
          <p>
            软件数量：<span>{{ productDetails.data && productDetails.data.length }}</span>
          </p>
          <p v-if="productDetails.liceseCode">
            注册码： <span>{{ productDetails.liceseCode }}</span>
          </p>
        </div>
        <div class="btm f-tac">
          <div class="price">退款金额：￥{{ productDetails.total_price }}</div>
          <template v-if="resultType === 0">
            <div class="reason">
              <!-- <div>退款理由（必填）<span style="color: #EA0000;">请填写退款理由</span></div>
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请描述您遇到的问题或退款理由"
                v-model="refundReason"
              >
              </el-input> -->
              <el-form
                label-position="top"
                :model="reasonForm"
                ref="reasonForm"
                label-width="100px"
              >
                <el-form-item
                  label="退款理由（必填）"
                  prop="reason"
                  :rules="[
                    { required: true, message: '请填写退款理由' },
                    { validator: noSpacesValidator, trigger: 'blur' }
                  ]"
                >
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请描述您遇到的问题或退款理由"
                    v-model="reasonForm.reason"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <el-button
              type="primary"
              class="btn-org"
              @click="submitRefund"
              :loading="btnLoadingSubmit"
              >提交退款申请</el-button
            >
          </template>
          <template v-else-if="resultType === 1">
            <div class="tips tips-suc">
              <img
                class="ic-img"
                src="@/assets/success.svg"
                width="100"
                height="100"
                alt=""
                style="box-shadow: 0px 20px 30px 0px rgba(44, 216, 147, 0.1);"
              />
              <p>您的退款申请已提交，客服会在5个工作日内处理您的退款申请，请耐心等待。</p>
            </div>
          </template>
          <template v-else>
            <div class="tips tips-err">
              <img
                class="ic-img"
                src="@/assets/wor.svg"
                width="100"
                height="100"
                alt=""
                style="box-shadow: 0px 20px 30px 0px rgba(255, 121, 25, 0.1);"
              />
              <p>网络遇到问题提交失败。</p>
              <p>请使用电子邮件将订单号、退款理由发送至：aomeitech@163.com</p>
              <p>客服会在5个工作日内处理您的退款申请。</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "../api/api";
export default {
  name: "Refund",
  data() {
    return {
      btnLoadingQuery: false,
      btnLoadingSubmit: false,
      productDetails: null,
      rules: {
        orderId: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      refundForm: {
        orderId: ""
      },
      reasonForm: {
        reason: ""
      },
      resultType: 0 // 0还没提交/1成功/2失败
    };
  },
  methods: {
    noSpacesValidator(rule, value, callback) {
      if (!value || value.trim().length === 0) {
        callback(new Error("请填写退款理由"));
      } else {
        callback();
      }
    },
    queryOrdersFn() {
      this.$refs["refundForm"].validate((valid) => {
        if (valid) {
          this.btnLoadingQuery = true;
          api
            .queryOrders(this.refundForm.orderId)
            .then((resp) => {
              if (resp.code == 200) {
                this.formatOrdersDetail(resp.data); // 格式化订单详情信息
              } else if (resp.code == 404) {
                this.$message({
                  showClose: true,
                  message: resp.msg,
                  type: "error"
                });
              } else if (resp.code == 403) {
                this.$message({
                  showClose: true,
                  message: resp.msg,
                  type: "warning"
                });
              }
            })
            .finally(() => {
              this.btnLoadingQuery = false;
            });
        }
      });
    },
    formatOrdersDetail(details) {
      const rawData = details;
      console.log(details, "details");
      const dealData = (({ order_no, show_name, show_version, data, liceseCode, total_price }) => {
        //处理序列号
        liceseCode = "";
        data.forEach((n) => {
          n.serial_numbers.forEach((item) => {
            // liceseCode.push(item);
            liceseCode = liceseCode + item + "、";
          });
        });
        // licese = liceseCode
        liceseCode = liceseCode.substring(0, liceseCode.lastIndexOf("、"));
        return {
          order_no,
          show_name,
          show_version,
          data,
          liceseCode,
          total_price
        };
      })(rawData);
      this.productDetails = dealData;
      console.log(this.productDetails, "888888888888888888888888888888888888");
      return dealData;
    },
    submitRefund() {
      //   this.btnLoadingSubmit = true;

      this.$refs.reasonForm?.validate((valid) => {
        console.log(this.$refs.reasonForm, valid);

        if (valid) {
          api
            .sendRefund({ id: this.productDetails.order_no, refund_reason: this.reasonForm.reason })
            .then((resp) => {
              if (resp.code == 200) {
                this.resultType = 1;
              } else {
                this.$message({
                  message: resp.msg,
                  type: "warning",
                  offset: 100
                });
              }
            })
            .finally(() => {
              this.btnLoadingSubmit = false;
            })
            .catch(() => {
              this.resultType = 2;
            });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.refund {
  padding: 80px 0;
  width: 100%;
  h2 {
    margin-bottom: 23px;
  }
  &-mn {
    background: #fff;
    border-radius: 10px;
    padding: 50px 50px 80px;
    width: 100%;
  }
  &-form {
    display: flex;
    vertical-align: middle;
    max-width: 1000px;
    input {
      width: 225px;
    }
    .el-form-item {
      // width: 330px;
      margin-right: 20px;
      flex: 1;
    }
    /deep/ .el-form-item__label {
      font-size: 18px;
    }

    .btn-bl {
      width: 200px;
      background: #203491;
      border-color: #203491;
      height: 40px;
      line-height: 30px;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.detail {
  margin-top: 50px;
  .txt-x {
    background: #f2f2f2;
    padding: 50px 80px;
    font-size: 18px;
    color: #000;
    border-radius: 10px;
    p:not(:last-child) {
      margin-bottom: 25px;
    }
  }
  .price {
    color: #203491;
    font-size: 40px;
    font-weight: bold;
    margin: 80px 0 50px;
  }
  .btn-org {
    font-size: 28px;
    width: 360px;
    height: 80px;
    line-height: 70px;
    border-radius: 10px;
    font-weight: bold;
  }
  .reason {
    text-align: left;
    margin-bottom: 40px;
  }
  .tips {
    color: #3d3d3d;
    padding: 80px 0 200px;
    font-size: 18px;
  }
  .ic-img {
    border-radius: 50%;
    margin-bottom: 20px;
  }
}

/deep/ .reason .el-form-item__error {
  top: -39px;
  left: 126px;
}
@media (max-width: 768px) {
  .refund- {
    &form {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .el-form-item {
        width: 100%;
        margin-right: 0;
      }
    }
    &mn {
      padding: 50px 15px 80px;
    }
  }
  .detail {
    .txt-x {
      padding: 50px 15px;
    }
    .btn-org {
      width: 300px;
    }
  }
}

@media (max-width: 480px) {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
